import { render, staticRenderFns } from "./pwa-installer.vue?vue&type=template&id=e9035fb8&"
import script from "./pwa-installer.vue?vue&type=script&lang=js&"
export * from "./pwa-installer.vue?vue&type=script&lang=js&"
import style0 from "./pwa-installer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports